import { id } from "date-fns/locale";
import HttpService from "./http.service";
class InventoryService {

    // Fetches all inventory items form the API
    getAllInventoryItems = async () => {
        const endpoint = 'inventory-items';
        return await HttpService.get(endpoint);
    };

    // Creates a new inventory item
    createInventoryItem = async (inventoryItem) => {
        const endpoint = 'inventory-items';
        return await HttpService.put(endpoint, inventoryItem);
    };

    // Fetches a single inventory item by id from the API
    getOneInventoryItem = async (id) => {
        const endpoint = `inventory-items/${id}`;
        return await HttpService.get(endpoint);
    };

    // Updates an inventory item
    updateInventoryItem = async (id, inventoryItem) => {
        const endpoint = `inventory-items/${id}`;
        return await HttpService.patch(endpoint, inventoryItem);
    };

    // Deletes an inventory item 
    deleteInventoryItem = async (id) => {
        const endpoint = `inventory-items/${id}`;
        return await HttpService.delete(endpoint);
    };

    // Generates an inventory report
    generateReport = async () => {
        const endpoint = 'inventory-items/gen';
        return await HttpService.get(endpoint);
    };

    // Adjusts the stock of an inventory item
    adjustStock = async (id, payload) => {
        const endpoint = `inventory-items/adjust-stock/${id}`;
        return await HttpService.patch(endpoint, payload);
    };

    // Fetches stock diversity data
    getStockDiversity = async () => {
        const endpoint = 'inventory-items/get/diversity';
        return await HttpService.get(endpoint);
    };

    getInventoryStats = async () => {
        const endpoint = 'inventory-items/get/stats';
        return await HttpService.get(endpoint);
    };

    getTotalQuantityByModel = async (id) => {
        const endpoint = `inventory-items/get/total-quantity-by-model/${id}`;
        return await HttpService.get(endpoint);
    };

    // Create a new reservation
    createReservation = async (payload) => {
        const endpoint = `inventory-items/rsrv/create`;
        return await HttpService.post(endpoint, payload);
    };

    // Get reservations for a specific inventory item
    getItemReservations = async (itemId) => {
        const endpoint = `inventory-items/rsrv/item/${itemId}`;
        return await HttpService.get(endpoint);
    };

    // Edit reservation status
    editReservationStatus = async (reservationId, payload) => {
        const endpoint = `inventory-items/rsrv/status/${reservationId}`;
        return await HttpService.patch(endpoint, payload);
    };
}

export default new InventoryService();